import { pubsub } from '@services';

class SearchInput extends HTMLElement {
  connectedCallback() {
    // Get elements
    this.searchInput = this.querySelector('input[type="search"]');

    // Handle search input
    this.searchInput.addEventListener('input', () => {
      this.publishEvent('search:input');
    });
  }

  /**
   * Clear the search input
   */
  clearSearchInput() {
    this.searchInput.value = '';
    this.publishEvent('search:clear');
  }

  /**
   * Publish the event
   */
  publishEvent(eventName) {
    pubsub.publish(`${eventName}:${this.id}`, {
      target: this.id,
      value: this.searchInput.value,
    });
  }
}

customElements.define('search-input', SearchInput);
